interface NobuLocalStoragePopupState {
    timer: string;
    expirationTime: string;
}

const timerSets = {
    '2': 3600, // 1 hour
    '3': 86400, // 1 day
    '4': 604800  // 1 week
};

export const popupLocalTimerState = (
    popupId: string,
    timerSetId: string
): boolean => {
    const localStorageItemName = 'nobu-popup-' + String(popupId);

    if (timerSetId === '1') {
        // reset to show always
        localStorage.removeItem(localStorageItemName);
        return true;
    }

    const currentTime = Date.now();
    const existingPopupExpirationData = localStorage.getItem(localStorageItemName);

    if (existingPopupExpirationData) {
        // existing data
        const existingExpirationTimer = JSON.parse(existingPopupExpirationData) as NobuLocalStoragePopupState;

        if (existingExpirationTimer.timer === timerSetId) {
            var existingExpirationTime =  Number(existingExpirationTimer.expirationTime);

            if (currentTime <= existingExpirationTime) {
                return false;
            }
            else {
                // expired: renew
            }
        }
        else {
            // changed: renew
        }

        localStorage.removeItem(localStorageItemName);
        return popupLocalTimerState(popupId, timerSetId);
    }

    // set new data
    const secondsToAdd = timerSets[timerSetId as keyof typeof timerSets];
    const expireTime: number = currentTime + (1000 * secondsToAdd);

    localStorage.setItem(localStorageItemName, JSON.stringify(<NobuLocalStoragePopupState>{
        timer: timerSetId,
        expirationTime: String(expireTime)
    }));

    return true;
};
